let answer = 0;

function Score()
{
    answer++;
}

export default Score;
export {answer};